<script>
export default {
  name: "ImgModal",
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showImgModal: false
    }
  }
}
</script>

<template>
  <div>
    <a href="#" @click.prevent="showImgModal = true">
      <slot></slot>
    </a>
    <div v-if="showImgModal" class="img-modal">
      <div class="top-bar">
        <el-button class="close" type="text" icon="el-icon-close" @click="showImgModal = false"></el-button>
        <a :href="require('@/assets/guide.png')" download><i class="el-icon-download"></i></a>
      </div>
      <div class="container">
        <ul class="img-list" v-if="type === 'guide'">
          <li>
            <img src="@/assets/guide1.webp" alt="" />
          </li>
          <li>
            <img src="@/assets/guide2.webp" alt="" />
          </li>
          <li>
            <img src="@/assets/guide3.webp" alt="" />
          </li>
          <li>
            <img src="@/assets/guide4.webp" alt="" />
          </li>
          <li>
            <br>
          </li>
        </ul>
        <ul class="img-list" v-else>
          <li>
            <img src="@/assets/guide5.webp" alt="" />
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>

<style scoped>
a,
a:active,
a:visited {
  color: #000;
}

.img-modal {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  position: fixed;
  background: #000;
}

.top-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .8em;
  color: white;
  background-color: #222;
}

.top-bar > a {
  display: block;
}
.top-bar /deep/ i {
  color: white;
  font-weight: bold;
  font-size: 1.25rem;
}
.top-bar /deep/ .el-button {
  padding: 0;
}

.container {
  margin-top: 45px;
  padding: 2em;
  overflow: scroll;
  height: calc(100vh - 45px);
}

.img-list {
  height: fit-content;
}
.img-list li img {
  background-color: #555;
  width: 100%;
}
.img-list li {
  margin-bottom: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/ImgModal.vue